// startup
// Load entry module and return exports
__webpack_modules__["./src/components/list/list.js"]();
__webpack_modules__["./src/components/list/_list.scss"]();
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["?6190"]();
